import Axios from './axios'

// 封装Common类型的接口方法
export class CommonService {
  // eslint-disable-next-line require-await
  static async getFriendList(data: any) {
    return Axios('/friend_link/list/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async getSearchTags(data: any) {
    return Axios('/search/everyone_search_tags/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async getIndexSearchInfo(data: any) {
    return Axios('/search/index_search_tags/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async getContentdetail(id: any) {
    return Axios('/ppt_template/content-detail-' + id, {
      method: 'get',
    })
  }
  // eslint-disable-next-line require-await
  static async getSpaceContentdetail(id: any) {
    return Axios('/ppt_template/space-content-detail-' + id, {
      method: 'get',
    })
  }
  // eslint-disable-next-line require-await
  static async getPreview(id: any) {
    return Axios('/common/genPreview/?id=' + id, {
      method: 'get',
    })
  }
  // eslint-disable-next-line require-await
  static async getToken() {
    return Axios('/common/get_token/', {
      method: 'get',
    })
  }
}

